import phone from '../images/mini_portal/employee-engagement/phone@2x.png'
import phone1 from '../images/mini_portal/employee-engagement/slide-02@2x.png'



import infoImage1 from '../images/mini_portal/Organization/info-1@2x.png'
import infoImage2 from '../images/mini_portal/Organization/info-2@2x.png'
import infoImage3 from '../images/mini_portal/Organization/info-3@2x.png'
import infoImage4 from '../images/mini_portal/Organization/info-4@2x.png'
import infoImage5 from '../images/mini_portal/Organization/info-5@2x.png'
import infoImage6 from '../images/mini_portal/Organization/info-6@2x.png'
import infoImage7 from '../images/mini_portal/Organization/info-7@2x.png'
import infoImage8 from '../images/mini_portal/Organization/info-8@2x.png'
import infoImage9 from '../images/mini_portal/Organization/info-9@2x.png'
import infoImage10 from '../images/mini_portal/Organization/info-10@2x.png'
import infoImage11 from '../images/mini_portal/Organization/info-12@2x.png'
import infoImage12 from '../images/mini_portal/Organization/info-13@2x.png'
import infoImage13 from '../images/mini_portal/Organization/info-14@2x.png'
import infoImage14 from '../images/mini_portal/Organization/info-15@2x.png'
import group2 from '../images/mini_portal/employee-engagement/group-3@2x.png'
import group3 from '../images/mini_portal/employee-engagement/card-15@2x.png'
import group4 from '../images/mini_portal/employee-engagement/group-3-copy-2@2x.png'
import mobilePhone1 from '../images/mini_portal/employee-engagement/group-9-copy12@2x.png'
import mobilePhone2 from '../images/mini_portal/employee-engagement/group-9-copy.png'
import mobilePhone3 from '../images/mini_portal/employee-engagement/group-9-copy@2x.png'
import mobilePhone4 from '../images/mini_portal/employee-engagement/group-9@2x.png'
import mobilePhone5 from '../images/mini_portal/employee-engagement/slide-02@2x.png'

export const infoList1 = [{
    id: '1',
    image: infoImage1,
    title: 'Announcements',
    description: 'Organisations can post announcements, updates, milestones & everything share-worthy to all employees, at the click of a button.'
}, {
    id: '2',
    image: infoImage2,
    title: 'Business Continuity Plan',
    description: 'Organisations when in the midst of emergency, can now empower employees with extra reassurance that assistance a touch away!'
}, {
    id: '3',
    image: infoImage3,
    title: 'Employee Directory',
    description: 'Find any fellow global or local employee based on Profile, Industry, Skills or Location. When you are travelling, the app will show the employee nearest to your location.'
},
    {
        id: '4',
        image: infoImage4,
        title: 'Profile',
        description: 'Get to know the employees. From their business, to the industries, skills, interests,  learning needs and family.'
    }];

export const infoList3 = [{
    id: '1',
    image: infoImage5,
    title: 'Mission Management',
    description: 'Set targets, review them against actuals & course correct proactively. Monitor via interactive dashboards for your business metrics & avoid time-intensive employee interactions. Also, the reports are hierarchy based, your view is unique!'
}, {
    id: '2',
    image: infoImage6,
    title: 'Leaderboard',
    description: 'Gamify work among teams! In real-time, motivate go-getters & fellow employees alike with reward points for achieving small & big milestones. Top performers are listed, for all to see!'
}]

export const infoList4 = [{
    id: '1',
    image: infoImage7,
    title: 'Polls',
    description: 'Create polls, get peer opinions on issues that matter to you without needing to send out a ton of mails.'

},
    {
        id: '2',
        image: infoImage8,
        title: 'Events',
        description: 'Large or small, restricted or public - manage events like a pro. Create and share event agenda. With the check-in feature - you get the attendee list in real time. ' +
        'Also digitize event feedback right here on Hubbler.'
    }, {
        id: '3',
        image: infoImage9,
        title: 'Special Interest Groups',
        description: 'No more dozens of WhatsApp groups to track and manage. Create, publish, find and connect with all your special interest groups in one place.'
    }, {
        id: '4',
        image: infoImage10,
        title: 'Channels',
        description: 'Organisations can create official channel for employees to visit for org. updates, training videos / docs, collaterals, etc. Also, employees can create Interest based channels.'
    }]

export const communityWebViewData = [{
    id: '1',
    image: phone,
    text: ['Quick access to favourite apps', 'Find an event of your interest, happening around you. If admin, track participation.', 'See the data that matters', `Celebrate successes and milestones - yours and your Colleagues!
    Latest updates on your Friends, mentors and others whom you follow `]
}, {
    id: '2',
    image: phone1,
    text: ['Welcome the new employees. Make them feel at home', '', '', 'Birthday / Anniversary Alerts\n' +
    'Wish on time - every time']
}]

export const infoList2 = [{
    id: '1',
    image: infoImage11,
    title: 'Library',
    description: 'Whether your employees are book readers, magazine readers, or newspaper readers; You can put 100s of e-books at their fingertips!'
},
    {
        id: '2',
        image: infoImage12,
        title: 'Learning Needs',
        description: 'Hubbler Connect hails your employees\' spirit of learning - from peers and from events. Just let us know your learning needs and we will connect you to your peers.'
    },
    {
        id: '3',
        image: infoImage13,
        title: 'Survey / Feedback',
        description: 'Take real-time feedback, create surveys to collect feedback from customers & employees, and get instant, detailed feedback reports.'
    },
    {
        id: '4',
        image: infoImage14,
        title: 'Marketplace',
        description: 'This is where you get what Alexa & Siri flounder to give you. Reach out to your peers when you need something or you wish to share something.'
    }
]
export const dashboardData = [{id:'1',name:'Employee Insights',discription:'More from the Core. We have built tools that will throw up information about your organisation’s activities and provide you with insight about events, SIG and integrations.',
    images:[group2,group3,group4]}];

export const communityMobileViewData = [{id:'1',image:mobilePhone1,name:'Quick access to favourite apps'},
    {id:'2',image:mobilePhone2,name:'See the data that matters'},
    {id:'3',image:mobilePhone3,name:'Find an event of your interest, happening around you, whether at home or travelling.'},
    {id:'4',image:mobilePhone4,name:'Celebrate successes and milestones - yours and your fellow Colleagues!'}, {id:'5',image:mobilePhone5,name:'Welcome the new employees. Make them feel at home'}]



// WEBPACK FOOTER //
// ./src/data/employee-engagement.js